import { connect } from 'react-redux';
import { ISeoData } from '../../types/seo';
import { IVillageForListPresenterSchema } from '../../../node/repositories/countryside-search/entities/village/VillageForListPresenterSchema';
import { IGetVillageListRequestSchema } from '../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { changeFilters, changePage } from '../../store/filters/actions';
import { generateVillageSerpLink } from '../../utils/filters';
import { getFormattedSeoData } from '../../utils/seo';
import { VillageListPage, MobileVillageListPage } from '../../components/VillageListPage';
import { IApplicationState, TTypedThunkDispatch } from '../../types/store';
import { numberToPrettyString, plural } from '@cian/utils';
import { FOUND_VARIANTS, OFFER_VARIANTS } from '../../interfaces/villages';

export interface IVillageListPageProps {
  filters: IGetVillageListRequestSchema;
  isFetching: boolean;
  pageHeading: string;
  regionHasRoads: boolean;
  regionHasStations: boolean;
  seoData?: ISeoData;
  serpLink: string;
  villageList: IVillageForListPresenterSchema[];
  refreshPage(filters: IGetVillageListRequestSchema): void;
  totalItems: string;
}

export type TVillageListPageStoreProps = Pick<
  IVillageListPageProps,
  | 'filters'
  | 'isFetching'
  | 'pageHeading'
  | 'regionHasRoads'
  | 'regionHasStations'
  | 'seoData'
  | 'serpLink'
  | 'villageList'
> & {
  totalItems: string;
};

export type TVillageListPageDispatchProps = Pick<IVillageListPageProps, 'refreshPage'>;

export function mapStateToProps(state: IApplicationState): TVillageListPageStoreProps {
  const {
    isFetching,
    filters,
    roads: { regionHasRoads },
    seo,
    stations: { regionHasStations },
    villageList: { villageList, breadcrumbs },
    mobile: { isMobileVersion },
  } = state;
  const oldPageHeading =
    breadcrumbs && breadcrumbs.length ? breadcrumbs[breadcrumbs.length - 1].title : 'Коттеджные посёлки';

  const totalItems = state.villageList.totalItems || 0;
  const totalItemsText = `${numberToPrettyString(totalItems)} ${plural(totalItems, OFFER_VARIANTS)}`;
  const seoData = getFormattedSeoData(seo.pageData?.seoData, villageList || [], totalItems);

  return {
    filters,
    isFetching,
    pageHeading: seoData?.h1 || oldPageHeading,
    regionHasRoads,
    regionHasStations,
    seoData,
    serpLink: generateVillageSerpLink(filters),
    villageList: villageList || [],
    totalItems: isMobileVersion ? totalItemsText : `${plural(totalItems, FOUND_VARIANTS)} ${totalItemsText}`,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): TVillageListPageDispatchProps {
  return {
    refreshPage: filters => {
      dispatch(changeFilters(filters));
      dispatch(changePage(filters.p || undefined, false, false));
    },
  };
}

export const VillageListPageContainer = connect<TVillageListPageStoreProps, TVillageListPageDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(VillageListPage);

export const MobileVillageListPageContainer =
  connect<TVillageListPageStoreProps>(mapStateToProps)(MobileVillageListPage);
